import React, { useEffect, useRef, useMemo } from 'react';

export const GalleryImage = ({ config }) => {
  const img = useRef();

  const handleImageDisplay = () => {
    const imgRatio = img.current?.naturalWidth / img.current?.naturalHeight;
    const containerRatio = img.current?.parentElement?.clientWidth / img.current?.parentElement?.clientHeight;

    if (imgRatio > containerRatio) {
      if (img.current.className.indexOf('crop-horiz') === -1) {
        img.current.className += ' crop-horiz';
      }
    } else {
      img.current.className = img.current.className.replace(/ crop-horiz/g, '');
    }
  };

  useEffect(() => {
    const handleResize = () => {
      handleImageDisplay();
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize)
  }, []);

  const image = useMemo(() => (
    <img ref={img} className="image-gallery-image" src={config.original} onLoad={handleImageDisplay} />
  ), [config.original]);

  return image
}
